import { CreateResumeDto, ResumeDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { incrementPerson, track } from "@/client/analytics/mixpanel";
import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";

export const createResume = async (data: CreateResumeDto) => {
  const response = await axios.post<ResumeDto, AxiosResponse<ResumeDto>, CreateResumeDto>(
    "/resume",
    data,
  );

  return response.data;
};

export const useCreateResume = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: createResumeFn,
  } = useMutation({
    mutationFn: createResume,
    onSuccess: (data) => {
      queryClient.setQueryData<ResumeDto>(["resume", { id: data.id }], data);

      queryClient.setQueryData<ResumeDto[]>(["resumes"], (cache) => {
        if (!cache) return [data];
        return [...cache, data];
      });

      // Invalidate pricing usage cache to reflect updated resume count
      queryClient.invalidateQueries({ queryKey: ["pricing", "usage"] });
      // No title: resumes are often named after the person.
      track("resume_created", { resume_id: data.id });
      incrementPerson("resumes_created_count");
    },
  });

  return { createResume: createResumeFn, loading, error };
};
